import React from 'react';
import Logo from './Components/Logo';
import ImageLink from './Components/ImageLink';
import RecognitionBox from './Components/RecognitionBox';
import './App.css';
import Particles from 'react-particles-js';
import Clarifai from 'clarifai';

const parameters = {
  "particles": {
    "number": {
      "value": 70,
    },
    "size": {
      "value": 3
    }
  },
  "interactivity": {
    "events": {
      "onhover": {
        "enable": true,
        "mode": "repulse"
      },
      "onclick": {
        "enable": true,
        "mode": 'push',
      }
    }
  }
};

const app = new Clarifai.App({
  apiKey: 'd55e2a885bca47df9b4303776e514d5f'
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: '',
      url: '',
      box: {},
    }
  }

  onInput = (event) => {
    this.setState({ input: event.target.value });
  }

  calculateFaceLocation = (data) => {
    console.log(data);
    const clarifaiFace = data.outputs[0].data.regions[0].region_info.bounding_box;
    const image = document.getElementById('inputImg');
    const width = Number(image.width);
    const height = Number(image.height);
    return {
      leftCol: clarifaiFace.left_col * width,
      topRow: clarifaiFace.top_row * height,
      rightCol: width - (clarifaiFace.right_col * width),
      bottomRow: height - (clarifaiFace.bottom_row * height)
    }
  }

  displayFaceBox = (box) => {
    console.log(box);
    this.setState({box: box});
  }

  onSubmit = () => {
    this.setState({imageUrl: this.state.input});
    app.models
      .predict(
        Clarifai.FACE_DETECT_MODEL,
        this.state.input)
      .then(response => {
        this.displayFaceBox(this.calculateFaceLocation(response))
      })
      .catch(err => console.log(err));
  }

  render() {
    return (
      <div className="App">
        <Particles className='particles' params={parameters} />
        <Logo />
        <ImageLink onInput={this.onInput} onSubmit={this.onSubmit} />
        <RecognitionBox boxVal={this.state.box} url={this.state.input} />
        {/*<Logo />
          <Rank />*/}
      </div>
    );
  }
}

export default App;
